export function isNumber(str: string): boolean {
  return !Number.isNaN(Number(str));
}
